import { render, staticRenderFns } from "./QuestionRow.vue?vue&type=template&id=728402c6&scoped=true&"
import script from "./QuestionRow.vue?vue&type=script&lang=ts&"
export * from "./QuestionRow.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionRow.vue?vue&type=style&index=0&id=728402c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728402c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
